import { render, staticRenderFns } from "./HotAd.vue?vue&type=template&id=9a08a42c&scoped=true&"
import script from "./HotAd.vue?vue&type=script&lang=js&"
export * from "./HotAd.vue?vue&type=script&lang=js&"
import style0 from "./HotAd.vue?vue&type=style&index=0&id=9a08a42c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a08a42c",
  null
  
)

export default component.exports